import Head from "next/head";
import ContentNotFound from "../components/ContentNotFound";
import Layout from "../components/layout";
import SEOMeta from "../components/SEOMeta";
import { getInnerPageContent } from "../lib/api";

export default function Advertise({ pageCont }) {
  if (!pageCont) return <ContentNotFound />;

  return (
    <Layout>
      <Head>
        <title>{pageCont[0].seo.title}</title>
        <SEOMeta seoData={pageCont[0].seo} />
      </Head>

      <main className="single-content mt-5 mb-5">
        <div className="container">
          <div className="row gap-5">
            <div className="col-lg-12">
              <article className="main-content-wrapper">
                <section className="content-sec">
                  <h1>{pageCont[0].title}</h1>
                  <div
                    dangerouslySetInnerHTML={{ __html: pageCont[0].content }}
                  />
                </section>
              </article>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export async function getStaticProps({ preview = false }) {
  const slug = "Advertise";
  const pageData = await getInnerPageContent(slug, preview);

  return {
    props: {
      preview,
      pageCont: pageData?.nodes ?? "",
    },
    revalidate: 60 * 60 * 24,
  };
}